
import { mapState, mapActions } from 'vuex'

export default {
  head() {
    return this.$metadata(this.story)
  },
  data() {
    return {
      story: {},
      accountNav: [
        {
          name: 'Inbox',
          path: '/account/inbox'
        },
        {
          name: 'Settings',
          path: '/account/settings'
        },
        {
          name: 'Order History',
          path: '/account/order-history'
        },
        {
          name: 'Offers',
          path: '/account/offers',
        }
      ]
    }
  },
  mounted() {
    if (!this.user) redirect('/account/login')
  },
  async mounted() {
    this.$storybridge.on(['input', 'published', 'change'], (event) => {
      if (event.action === 'input') {
        if (event.story.id === this.story.id) {
          this.story.content = event.story.content
        }
      } else {
        window.location.reload()
      }
    })
    // User went through guest checkout and needs to update Braze with details from guest checkout
    if(this.createAccount && this.guestUser){
      // Update communication preferences in Braze
      this.$braze.getUser().setCustomUserAttribute('SMS_Channel_Opt_In', this.guestUser.optin_sms ? true : false)
      this.$braze.getUser().setPushNotificationSubscriptionType(this.guestUser.optin_sms ? this.$braze.User.NotificationSubscriptionTypes.SUBSCRIBED : this.$braze.User.NotificationSubscriptionTypes.UNSUBSCRIBED)
      if (this.guestUser.optin_sms && this.$braze.isPushSupported()) {
        this.$braze.requestPushPermission(
          () => {
            window.alert(`You are registered for Bojangles notifications!`)
          },
          () => {
            window.alert(`Something went wrong. With notification registration.`)
          }
        )
      }
      this.$braze.getUser().setEmailNotificationSubscriptionType(this.guestUser.optin ? this.$braze.User.NotificationSubscriptionTypes.OPTED_IN : this.$braze.User.NotificationSubscriptionTypes.UNSUBSCRIBED)
      // Log guestUser purchases from first order
      if(this.guestUser.order){
        this.guestUser.order.products.forEach(product => {
          this.$braze.logPurchase(
            product.name.toString(),
            product.cost.total.toString(),
            'USD',
            product.quantity,
            this.order.time
          )
        })
      }
      // Set Braze attributes on new Account Created
      const res = await this.$api.getFaveLocations()
      const favs = []
      let registrationCompletedEvent = this.channel !== 'catering' ? 'Registration_Completed' : 'Registration_Complete_Catering';
      res.favelocations.forEach(loc => { favs.push({
          "Store_ID": loc.store_num.toString(),
          "Menu_ID": loc.menu_id.toString(),
          "Name": loc.name.toString(),
          "City": loc.city.toString(),
          "State": loc.state.toString(),
          "Zip": loc.zip.toString(),
          "Availability": [
            ...(loc.services.pickup ? ['pickup'] : []),
            ...(loc.services.curbside ? ['curbside'] : []),
            ...(loc.services.delivery ? ['delivery'] : []),
            ...(loc.services.drivethru ? ['drivethru'] : []),
            ...(loc.services.dinein ? ['dinein'] : []),
            ...(loc.services.manualfire ? ['manualfire'] : []),
          ].join(', ')
        })
      })
      this.$braze.getUser().setCustomUserAttribute("Favorite_Locations", favs)
      this.$braze.getUser().setEmail(this.user.email)
      this.$braze.getUser().setFirstName(this.user.first_name)
      this.$braze.getUser().setLastName(this.user.last_name)
      this.$braze.getUser().setPhoneNumber(this.user.phone.length == 10 ? '+1' + this.user.phone : this.user.phone)
      // Registration of new user account completed
      this.$braze.logCustomEvent(registrationCompletedEvent, { 'User': this.user })
      // Set guestUser and createAccoute to false since we're done
      this.$store.commit('setCreateAccount', false)
      this.$store.commit('setGuestUser', null)
    }
  },
  methods: {
    ...mapActions([
      'accountLogout' // also supports payload `this.nameOfAction(amount)`
    ]),
    async logout() {
      if(this.order && this.order.products.length) {
        console.log("ABANDON")
        if (this.channel == 'catering') {
          this.$braze.logCustomEvent('Abandon_Cart_Catering', {'Cart_Items': this.order.products, 'Cart_Cost': this.order.totals.total})
        } else {
          this.$braze.logCustomEvent('Abandon_Cart', {'Cart_Items': this.order.products, 'Cart_Cost': this.order.totals.total})
        }
      }
      this.$api.logoutUser()
      const handoff = JSON.parse(JSON.stringify(this.handoff))
      handoff['email'] = ''
      this.$store.commit('setHandoff', handoff)
      // this.accountLogout()
      // setTimeout(() => {
      this.$router.push('/')
      // }, 1000)
    }
  },
  async asyncData({ $storyblok, store, route, redirect }) {
    try {
      const story = await $storyblok.getStory('account')
      return {
        story: story
      }
    } catch (error) {
      console.error(error)
    }
  },
  computed: {
    ...mapState(['location', 'menu', 'user', 'guestUser', 'createAccount', 'handoff', 'order', 'channel']),
  }
}
